import type { Page } from "../types";

class AndroidCallbackPage implements Page {
  constructor() {}

  mount(root: HTMLElement) {
    root.innerHTML = `
      <main class="kdl-deeplink-page">
        <div class="kdl-deeplink-page__content">
          <div class="kdl-deeplink-page__loader" aria-hidden="true"></div>
        </div>
      </main>
    `;
  }
}

export { AndroidCallbackPage };
